module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal-dialog modal-lg" role="document">\r\n    <div class="modal-content">\r\n        <div class="modal-header">\r\n            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\r\n            <h2 class="modal-title" id="myModalLabel">\r\n                ';
 switch(tablename){
                    case "registrales": print(lang.REGISTRALES); break;
                    case "catastrales": print(lang.CATASTRALES_G); break;
                    case "acuerdos": print(lang.ACUERDOS); break;
                    case "titulos": print(lang.TITULOS); break;
                    case "mejoras": print(lang.MEJORAS); break;
                    default: print("MASTERS");
                } 
__p+='\r\n            </h2>\r\n        </div>\r\n        <div class="modal-body">\r\n            <form id="masters">\r\n                <div class="tab-pane active">\r\n                    ';
 
                    var fields = [];
                    
                    if(_.size(attributes))
                        for(var i in attributes){
                            var field = {
                                id: i,
                                value: attributes[i]
                            }
                            for(var j in desc){
                                if(i === desc[j].Field){
                                    field.type = desc[j].Type.substring(0,3);
                                }
                            }

                            fields.push(field);
                        }
                    else{
                        for(var i in desc){
                            var field = {
                                id: desc[i].Field,
                                type: desc[i].Type.substring(0,3),
                                value: ''
                            }

                            fields.push(field);
                        }
                    }

                    /* var accounts = {};
                    for(c in cuentas){                        
                        accounts[c] = cuentas[c];                        
                    } */

 
                    for(var i in fields){
   

                        var disabled = "";
                        if(   fields[i].id==="mejoras_enCurso" || fields[i].id==="id" || fields[i].id ==="itemId" || fields[i].id==="mejoras_vida" || fields[i].id==="mejoras_amortizacion" 
                                               || fields[i].id==="mejoras_vnc" || (fields[i].id ==="good_id"  && _.size(attributes)))
                            disabled = "disabled";

                        if(fields[i].id==="value" || fields[i].id==="button" || fields[i].id==="mejoras_area" || fields[i].id==="mejoras_amorAcum" 
                                                  || fields[i].id==="instanceId" || fields[i].id==="user_id")
                            continue;

                        print('<div class="form-group col-md-3 col-sm-6 col-xs-12">');

                        if(fields[i].id==="mejoras_cuenta"){

                            if(attributes["mejoras_enCurso"] == "Sí"){
                                print('<label for="' + fields[i].id + '">' + lang[fields[i].id.toUpperCase()] + '</label>');
                                print('<input type="text" value="' + fields[i].value + '" id="' + fields[i].id + '" class="form-control  money   text-left"  />');
                            }else{
                            print('<label for="' + fields[i].id + '">' + lang[fields[i].id.toUpperCase()] + '</label>');
                            print('<select  disabled="disabled" id="' + fields[i].id + '" class="form-control">');
                                
                            for(var c in accounts){
                                var selected = "";
                                if(accounts[c] + ' - '  + lang[c] === fields[i].value)
                                    selected = "selected";
                                
                                print('<option value="' + c + '" ' + selected + '>' + accounts[c] + ' - '  + lang[c] + '</option>')
                            }
                            print('</select>');
                            }
                            
                           
                        } else if(fields[i].id==="item_id"){
                            // Do nothing
                        } else if(fields[i].id==="catastrales_naturaleza"){
                               //Esto para más adelante
                        } else if(fields[i].id==="registrales_obs"){
                              ///// ESTO YA NO ESTA QUITADO 
                        } else if(fields[i].id==="is_mejorarazonable"){
                              ///// ESTO YA NO ESTA QUITADO 
                        } else if(fields[i].id==="catastrales_obs"){
                              ///// ESTO YA NO ESTA QUITADO 
                        } else if(fields[i].id==="acuerdos_organo"){
                               //Esto para más adelante
                        } else if(  fields[i].id==="mejoras_importe" || fields[i].id==="mejoras_vnc"){
                            
                                var decimaVal = fields[i].value; 

                                if (typeof decimaVal === "undefined" || decimaVal=== null){ 
                                   
                                }else{
                                    
                                }
 
                                  
                                print('<label for="' + fields[i].id + '">' + lang[fields[i].id.toUpperCase()] + '</label>');
                                print('<input type="text" value="' +  decimaVal  + '" id="' + fields[i].id + '" class="form-control  money   text-right" ' + disabled + '/>');
                        } else{

                             

                            print('<label for="' + fields[i].id + '">' + lang[fields[i].id.toUpperCase()] + '</label>');
                            switch(fields[i].type){
                                case "dat":
                                    print('<div id="dtpickerMaster" class="input-group dateGroup ">');
                                    print('<input placeholder="mm/dd/yyyy"  type="text" value="' + fields[i].value + '" id="' + fields[i].id + '"  name="start"  class="date value form-control" ' + disabled + '/>');
                                    print('<span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span></span></div>');
                                    break;
                                case "dec":
                                case "flo":
                                        
                                var decimaVal = fields[i].value; 
                                decimaVal = decimaVal.replace(".", ",") 
                                
                                fields[i].value =  decimaVal;
                                
                                
                                    print('<input type="text" value="' + fields[i].value + '" id="' + fields[i].id + '" class="form-control decimal text-right" ' + disabled + '/>');
                                    break;
                                case "int":
                                case "tin":
                                    print('<input type="text" value="' + fields[i].value + '" id="' + fields[i].id + '" class="form-control justnumber text-right" ' + disabled + '/>');
                                    break;
                                    //String
                                case "var":
                                    print('<input type="string" value="' + fields[i].value + '" id="' + fields[i].id + '" class="form-control" ' + disabled + '/>');
                                    break;
                                default:
                                    print('<input type="string" value="' + fields[i].value + '" id="' + fields[i].id + '" class="form-control" ' + disabled + '/>');
                                break;
                            }
                        }
                        print('</div>');
                    }
                    
__p+='\r\n                </div>\r\n            </form>\r\n        </div>\r\n        <div class="modal-footer">\r\n            ';
 if(rolee != 3){ 
__p+='\r\n                <div class="col-md-6 col-xs-6 text-left">\r\n                    <button type="reset" class="btn btn-flat btn-success" id="save">'+
((__t=(lang.SAVE))==null?'':_.escape(__t))+
'</button>\r\n                </div>\r\n                ';
 } 
__p+='\r\n                    <div class="col-md-s col-xs-6 text-right">\r\n                        <button type="reset" class="btn btn-flat btn-danger" id="cancel">'+
((__t=(lang.CANCELAR))==null?'':_.escape(__t))+
'</button>\r\n                    </div>\r\n        </div>\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/masters/mastersViewDetail.ejs
// module id = 430
// module chunks = 0